import React from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import Chip from "../components/Chip";
import { FileData, FileSummary } from "../types";
import { getChipVariant } from "../utils";
import * as styles from "./styles_vanilla.css";

interface DataFilesEntityChoicesProps {
  files: FileData[];
  fileSummary: FileSummary;
}

const DataFilesEntityChoices: React.FC<DataFilesEntityChoicesProps> = ({
  files,
  fileSummary,
}) => {
  return (
    <Flex flexDirection="column" gap={Sizes.LG} className={styles.container}>
      <Flex className={styles.sectionHeader}>
        <Flex className={styles.sectionIcon}>
          <Icon type="file-alt" size="medium" color={Colors.Neutral600} />
        </Flex>
        <Flex flexDirection="column">
          <Text className={styles.sectionTitle}>Data Files & Entity Choices</Text>
          <Text className={styles.sectionSubtitle}>
            Review the files uploaded and entity types selected in Step 2
          </Text>
        </Flex>
      </Flex>

      <Flex className={styles.summaryStats}>
        <Flex flexDirection="column" className={styles.statItem}>
          <Text className={styles.statNumber}>{fileSummary.totalFiles}</Text>
          <Text className={styles.statLabel}>Files</Text>
        </Flex>
        <Flex flexDirection="column" className={styles.statItem}>
          <Text className={styles.statNumberGreen}>{fileSummary.totalSize}</Text>
          <Text className={styles.statLabel}>KB Total</Text>
        </Flex>
        <Flex flexDirection="column" className={styles.statItem}>
          <Text className={styles.statNumberBlue}>{fileSummary.dataTypes}</Text>
          <Text className={styles.statLabel}>Data Types</Text>
        </Flex>
      </Flex>

      <Flex flexDirection="column">
        <Text
          variant="regular-md"
          color={Colors.Neutral700}
          className={styles.fileDetailsHeader}
        >
          File Details
        </Text>
        <Flex flexDirection="column" className={styles.filesList}>
          {files.map((file, index) => (
            <Flex key={file.id} className={styles.fileCard}>
              <Flex className={styles.fileIcon}>
                <Icon type="file-alt" size="medium" />
              </Flex>
              <Flex flexDirection="column" className={styles.fileDetails}>
                <Text className={styles.fileName}>{file.fileName}</Text>
                <Text className={styles.fileMetadata}>{file.fileSize}</Text>
                <Chip variant={getChipVariant(file.entityType)}>{file.entityType}</Chip>
              </Flex>
              <Flex className={styles.fileNumber}>#{index + 1}</Flex>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DataFilesEntityChoices;
